export const SpicySvg = () => {
  return (
    <svg
      fill="#ff2922"
      width="20"
      height="20"
      viewBox="0 0 512.511 512.511"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="M506.861,133.809c1.6-5.6,2.4-25.6-24-42.8c5.2-17.2,7.6-44.4-2.8-67.2c-0.8-2-3.2-2.8-5.2-2l-31.2,11.6
			c-1.2,0.4-2,1.2-2.4,2.4c-0.4,1.2,0,2.4,0.4,3.6c6.4,9.2,16.4,26.8,16.8,44.4c-16.8-1.2-39.2,3.2-47.2,18
			c-6.8,2.8-13.2,6.4-19.2,10.8c-23.6,17.2-33.2,54.4-44.8,97.6c-28,105.6-66.4,250.8-333.6,241.6c-9.2-0.4-13.2,4.8-13.6,10
			c-0.8,8.4,6.4,18.4,15.2,20c34.8,6.4,68.8,9.2,101.6,9.2c104,0,197.2-30.4,269.6-89.2c76.4-62,123.6-151.2,126-238.8
			C512.861,152.609,510.861,143.009,506.861,133.809z M426.061,108.609c5.2,0.4,8,1.6,8.8,2.8L426.061,108.609z"
          />
        </g>
      </g>
    </svg>
  );
};
